import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

const BaseBubble = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '$core.spacing.200',
  paddingRight: '$core.spacing.200',
  paddingTop: '$core.spacing.150',
  paddingBottom: '$core.spacing.150',
  borderWidth: '$core.border-width.sm',
  borderStyle: 'solid',
});

export const UserBubble = styled(BaseBubble, {
  alignSelf: 'flex-end',
  border: '1px solid $core.color.brand.60',
  backgroundColor: '$core.color.brand.60',
  borderRadius: '$core.border-radius.md',
  fontWeight: '$web.core.font-weight.uhc2020-sans.bold',
  borderBottomRightRadius: 5,
  color: '$core.color.neutral.0',
});

export const LoaderBubble = styled(BaseBubble, {
  alignSelf: 'flex-end',
  border: '1px solid $core.color.neutral.20',
  backgroundColor: '$core.color.neutral.0',
  borderRadius: '$core.border-radius.md',
  fontWeight: '$web.core.font-weight.uhc2020-sans.bold',
  borderBottomRightRadius: 5,
  color: '$core.color.neutral.90',
  marginTop: '$core.spacing.100',
});

export const BotBubble = styled(BaseBubble, {
  alignSelf: 'flex-start',
  borderRadius: '$core.border-radius.md',
  borderBottomLeftRadius: 5,
  borderColor: '$core.color.brand.10',
  backgroundColor: '$core.color.brand.10',
  color: '$core.color.neutral.100',
  fontFamily: '$web.core.font-family.sf-pro-text-regular !important',
  marginTop: '$core.spacing.100',
});

export const BubbleTimestamp = styled(Text, {
  marginTop: '$core.spacing.50',
  alignSelf: 'flex-start',
  color: '$core.color.neutral.60',
  fontFamily: '$web.core.font-family.sf-pro-text-regular !important',
  fontSize: '10px',
  background: 'red',
});
